baguetteBox.run('#gallery', {buttons: true});
